import {
  Button,
  type ButtonProps,
  Flex,
  Modal,
  PasswordInput,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconDeviceFloppy, IconX } from "@tabler/icons-react";
import { type ChangeEvent, type FormEvent, useCallback, useState } from "react";
import { SmallDivider } from "src/styled";

interface Props extends ButtonProps {
  onSubmit: (authpw: string) => void;
  validate?: () => boolean | Promise<boolean>;
}

const CrewAuthButton = ({ onSubmit, validate, ...buttonProps }: Props) => {
  const [opened, { open, close }] = useDisclosure();
  const [authpw, setAuthpw] = useState("");

  const handleClick = useCallback(async () => {
    if (validate) {
      const result = await validate();
      if (!result) return;
    }
    open();
  }, [open, validate]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setAuthpw(event.target.value);
  }, []);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit(authpw);
    setAuthpw("");
    close();
  };

  return (
    <>
      <Button {...buttonProps} onClick={handleClick} />
      <Modal
        size="lg"
        opened={opened}
        onClose={close}
        withCloseButton={false}
        yOffset={"25dvh"}>
        <Text>Authorization is required!</Text>
        <SmallDivider />
        <form onSubmit={handleSubmit}>
          <Flex direction="column" w="80%" mt="xl" mx="auto" gap="xl">
            <Text>
              If you have changed your own credentials, please re-enter your OLD
              password to confirm this change.
            </Text>
            <Text>
              If you are changing the details of another user, please create a
              new user. Sharing login details is not permitted.
            </Text>
            <Text>
              Please re-enter your password to confirm this change is for this
              user.
            </Text>
            <Flex align="center" gap="xl">
              <Text w="max-content">Your Password</Text>
              <PasswordInput
                style={{ flex: 1 }}
                value={authpw}
                onChange={handleChange}
              />
            </Flex>
          </Flex>
          <Flex justify="flex-end" gap="sm" mt="xl">
            <Button
              leftSection={<IconX size={"1rem"} />}
              mr={5}
              color="red"
              onClick={close}>
              Cancel
            </Button>
            <Button
              leftSection={<IconDeviceFloppy size={"1rem"} />}
              disabled={authpw.length === 0}
              type="submit">
              Submit
            </Button>
          </Flex>
        </form>
      </Modal>
    </>
  );
};

export default CrewAuthButton;
